import { call, put, takeEvery, select, takeLatest } from 'redux-saga/effects'
import {
  types,
  ICreateDataChartAction,
  ICreateDataChartPollingSuccessAction,
  ICreateDataChartPollingFailureAction,
} from '../types/datachart'
import { push } from '../actions/router'
import * as packActions from '../actions/pack'
import * as pollingActions from '../actions/polling'
import * as actions from '../actions/datachart'
import * as packSelectors from '../selectors/pack'
import * as services from '../services/datastream'
import { trace } from '../services/common'
import { messages } from '../config/messages'

export function* createDataChartSaga(action: ICreateDataChartAction) {
  try {
    const packId = yield select(packSelectors.selectPackId)
    const taskData = yield call(
      services.createEditionFromDataChart,
      packId,
      action.title,
      action.dataStreamURI
    )
    const { location } = taskData
    yield put(
      pollingActions.dataPollingAction(
        location,
        Date.now(),
        actions.createDataChartPollingSuccess,
        actions.createDataChartPollingFailure
      )
    )
  } catch (err) {
    trace(err)
    yield put(actions.createDataChartFailure(err.message, err.correlationId))
  }
}

export function* createDataChartPollingSuccessSaga(
  action: ICreateDataChartPollingSuccessAction
) {
  try {
    const packId: string = yield select(packSelectors.selectPackId)
    const groupId: string = yield select(packSelectors.selectParentGroup)
    const editionId = action.data.editionId
    const editionName = 'DataStream-Chart.html'
    yield put(
      actions.createDataChartSuccess(
        messages.createEditionForDatachartCreateSuccess(editionName)
      )
    )
    yield put(packActions.getPackById(packId))
    yield put(
      push(`/group/${groupId}/pack/${packId}?edition=${editionId}&tab=publish`)
    )
  } catch (err) {
    trace(err)
    yield put(actions.createDataChartFailure(err.message, err.correlationId))
  }
}

export function* createDataChartPollingFailureSaga(
  action: ICreateDataChartPollingFailureAction
) {
  try {
    yield put(
      actions.createDataChartFailure(action.message, action.correlationId)
    )
  } catch (err) {
    trace(err)
    yield put(actions.createDataChartFailure(err.message, err.correlationId))
  }
}

export function* datachartWatcher() {
  yield takeEvery(types.CREATE_DATACHART__STARTED, createDataChartSaga)
  yield takeLatest(
    types.CREATE_DATACHART_POLLING__SUCCESS,
    createDataChartPollingSuccessSaga
  )
  yield takeLatest(
    types.CREATE_DATACHART_POLLING__FAILURE,
    createDataChartPollingFailureSaga
  )
}
